export default function(bounds, item) {
  if (item.stroke && item.opacity !== 0 && item.strokeOpacity !== 0) {
    bounds.expand(item.strokeWidth != null ? +item.strokeWidth : 1);
  }
  return bounds;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-scenegraph/src/bound/boundStroke.js
// module id = null
// module chunks = 